export default __webpack_public_path__ + "static/media/mesozoic_mayhem.954beeed.svg";